"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
require("./AllCardsView.css");
var Tab_1 = __importDefault(require("@material-ui/core/es/Tab/Tab"));
var Tabs_1 = __importDefault(require("@material-ui/core/es/Tabs/Tabs"));
var Character_1 = require("../models/Character");
var Icons_1 = require("./icons/Icons");
var CharacterSelection = /** @class */ (function (_super) {
    __extends(CharacterSelection, _super);
    function CharacterSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CharacterSelection.prototype.render = function () {
        var store = this.props.characterDataStore;
        return (react_1.default.createElement(Tabs_1.default, { value: Character_1.CharacterTypes.indexOf(store.selectedCharacter), onChange: function (_, newCharacter) {
                store.setSelectedCharacter(Character_1.CharacterTypes[newCharacter]);
            }, indicatorColor: "primary", textColor: "primary", fullWidth: true }, Icons_1.CharacterIcons.map(function (icon, i) {
            return (react_1.default.createElement(Tab_1.default, { style: { minWidth: "3rem" }, icon: icon, key: i }));
        })));
    };
    CharacterSelection = __decorate([
        mobx_react_1.inject("characterDataStore"),
        mobx_react_1.observer
    ], CharacterSelection);
    return CharacterSelection;
}(react_1.Component));
exports.default = CharacterSelection;



//////////////////
// WEBPACK FOOTER
// ./src/components/CharacterSelection.tsx
// module id = 782
// module chunks = 0